import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  return (
    <nav className={styles.main_nav}>
      <div className={styles.nav}>
        <Link to="/">
          <img
            src={process.env.PUBLIC_URL + "/logo.png"}
            className={styles.logo}
            alt="Your Logo"
            height="50"
          />
        </Link>

        {/* Hamburger Icon */}
        <button className={styles.hamburger} onClick={toggleMenu}>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
          <span className={styles.bar}></span>
        </button>

        {/* Menu */}
        <ul className={`${styles.menus} ${isMenuOpen ? styles.open : ""}`}>
          <li className={location.pathname === "/" ? styles.active : ""}>
            <Link to="/">Home</Link>
          </li>
          <li className={location.pathname === "/sgx_nifty" ? styles.active : ""}>
            <Link to="/sgx_nifty">SGX Nifty</Link>
          </li>
          <li className={location.pathname === "/zerodha" ? styles.active : ""}>
            <Link to="/zerodha">Zerodha</Link>
          </li>
          <li className={location.pathname === "/upstox" ? styles.active : ""}>
            <Link to="/upstox">Upstox</Link>
          </li>
          <li className={location.pathname === "/fyers" ? styles.active : ""}>
            <Link to="/fyers">Fyers</Link>
          </li>
          <li className={location.pathname === "/contact_us" ? styles.active : ""}>
            <Link to="/contact_us">Contact Us</Link>
          </li>
          <li className={location.pathname === "/about_us" ? styles.active : ""}>
            <Link to="/about_us">About Us</Link>
          </li>

          {/* Login/Signup Button - Inside Hamburger menu for mobile */}
          <li
            className={location.pathname === "/getin" ? styles.disappear : ""}
            style={{ marginTop: "15px" }} // Added margin for spacing in the mobile menu
          >
            <Link to="/getin">
              <button className={styles.loginButton}>Login / Signup</button>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
